<div id="resizable" class="panel" @slideInOut>
    <div id="drag-handle"></div>
    <div class="panel__header">
        <div class="flex items-center name">
            <button mat-icon-button aria-label="Close" (click)="onCloseClick()">
                <mat-icon class="color-gray16" svgIcon="close" />
            </button>
            <app-tooltip class="text-lg" [isEnabled]="isTitleOverflowing">
                <span trigger #headerTitleEl class="text">
                    {{ headerTitle }}
                </span>

                <div content>
                    {{ headerTitle }}
                </div>
            </app-tooltip>
        </div>
        <div class="content ml-4">
            <ng-content select="[headerContent]" />
        </div>
        <div class="header-actions flex items-center gap-4 ml-auto">
            <ng-content select="[headerActions]" />
            <app-flat-button
                variant="cta"
                class="button"
                [dataQa]="headerPrimaryButtonDataQa"
                [disabled]="headerPrimaryButtonDisabled"
                (clicked)="onPrimaryButtonClick()">
                {{ headerPrimaryButtonLabel }}
            </app-flat-button>
        </div>
    </div>
    <div id="content"><ng-content /></div>
</div>
